import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
const padding = 70
export const StyleModal = styled.div`
  .content-Modal{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_5};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: 15%;
    height: 350px;
    width: ${600 - padding}px;
    font-size: ${FONT_SIZE.SM};
    padding-top: 150px;
    padding-left: ${padding}px;
    padding-right: ${padding}px;
    text-align: center;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }



  .text-modal{
    font-size: ${FONT_SIZE.XXL};
    font-weight: bold;
    letter-spacing: 1px;
  }

  .description{
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.GRAY_3};
  }

  .center {
    width: 101%;
  }


  .input, .select{
    margin-top: 10%;
    border: none;
    border-bottom: 1px solid ${COLOR.GRAY_7};
    width: 100%;
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    outline: none;
    text-align: center;
    color:  ${COLOR.BLACK_1};
  }

  .select{
    margin-top: 15%;
  }

  .table-row {
    margin-bottom: 15%;
  }

  .btn-confirm, .btn-cancel-modal{
    width: 120px;
    margin-top: 15%;
    font-size: ${FONT_SIZE.TN};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.SM};
    float: none;
  }

  .btn-confirm{
    background: ${COLOR.BLUE_1};
    margin-left: 8%;

  }
  .btn-cancel-modal{
    background: ${COLOR.BLACK_2};
    margin-right: 8%;
  }

  input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.GRAY_3};
  }


  .text-error{
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: ${FONT_SIZE.TN};
    color: ${COLOR.RED_2};
  }
`
